var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[("" + (_vm.component.toLowerCase())), 'c-base-section']},[_c('BaseSectionHeading',{attrs:{"data":_vm.data}}),_c(_vm.component,{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }